
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug1]",
      function () {
        return require("private-next-pages/[slug1]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug1]"])
      });
    }
  